export default {
    init: () => {
        if (!localStorage) {
            window.localStorage = {
                setItem: function (key, data) {
                    this[key] = data
                },
                removeItem: function (key) {
                    this[key] = undefined
                    delete this[key]
                },
                getItem: function (key) {
                    return this[key]
                }
            }
        }
    }
}
